import { useEffect, useRef } from 'react';

interface UseInfiniteScrollOptions {
  onIntersect: () => void;
  disabled?: boolean;
  rootMargin?: string;
}

export const useInfiniteScroll = ({
  onIntersect,
  disabled = false,
  rootMargin = '200px',
}: UseInfiniteScrollOptions) => {
  const sentinelRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (disabled || !sentinelRef.current) return;

    const observer = new IntersectionObserver(
      entries => {
        const [entry] = entries;
        if (entry.isIntersecting) {
          onIntersect();
        }
      },
      { rootMargin },
    );

    const el = sentinelRef.current;
    observer.observe(el);

    return () => {
      if (el) observer.unobserve(el);
    };
  }, [onIntersect, disabled, rootMargin]);

  return sentinelRef;
};

export default useInfiniteScroll;
